<template>
  <div>
    <InputSkeleton
      v-for="[k, v] in paramsProcessed"
      :key="k"
      :value-key="k"
      :value="v"
      :on="$listeners"
    />
  </div>
</template>
<script>
import InputSkeleton from "./InputSkeleton.vue";
import { camelCase } from "lodash-es";

export default {
  name: "AppShowInputSkeleton",
  components: {
    InputSkeleton
  },
  props: {
    params: {
      type: Object,
      required: true
    },
    orderPreset: {
      type: String,
      default: null
    }
  },
  computed: {
    paramsProcessed() {
      const orderPreset = this.orderPreset
        ? this[this.orderPreset + "Order"]
        : undefined;

      return Object.entries(this.params)
        .reduce(
          ([ordered, unordered], [k, v]) => {
            if (!v) return [ordered, unordered];

            k = camelCase(k);
            if ((orderPreset?.[k] ?? -1) >= 0) {
              // Set input in specific index order
              ordered[orderPreset[k]] = [k, v];
            } else {
              unordered.push([k, v]);
            }
            return [ordered, unordered];
          },
          [[], []]
        )
        .flat()
        .filter(Boolean); // Filter out undefined index values
    },
    productParamsOrder() {
      return {
        personId: 0,
        disciplineId: 1,
        year: 2,
        clubId: 3
      };
    }
  }
};
</script>
